import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { Comment_AddComment_RequestBody, CommentAPIs } from '~/common/typescript/apis/CommentAPIs';
import { currentProjectAtom } from '~/stores/ProjectStore';
import { userInformationAtom } from '~/stores/UserStore';
import { showCommentPanelAtom } from '../../stores/mapStore';
import {
  commentsAtom,
  focusedCommentIdAtom,
  newlyCreatedCommentIdAtom,
} from '../../Comment/CommentStore';

export interface AddCommentInitialData {
  title?: string;
  description?: string;
  mentionedUserIds?: number[];
}

export const useAddCommentAtCoordinates = () => {
  const [currentProject] = useAtom(currentProjectAtom);
  const loggedUser = useAtomValue(userInformationAtom);
  const [comments, setComments] = useAtom(commentsAtom);
  const setNewlyCreatedCommentId = useSetAtom(newlyCreatedCommentIdAtom);
  const setFocusedCommentId = useSetAtom(focusedCommentIdAtom);
  const setShowCommentPanel = useSetAtom(showCommentPanelAtom);

  const addCommentAtCoordinates = async (
    lng: number,
    lat: number,
    initialData?: AddCommentInitialData,
  ) => {
    if (!currentProject?.id) {
      console.error('No current project selected');
      return;
    }

    try {
      const payload: Comment_AddComment_RequestBody = {
        projectId: currentProject.id,
        title: initialData?.title || 'Chưa điền tiêu đề',
        description: initialData?.description || 'Chưa điền mô tả',
        mentionedUserIds: initialData?.mentionedUserIds,
        geojson: JSON.stringify({
          type: 'point',
          coordinates: [lng, lat],
        }),
      };

      const result = await CommentAPIs.remote_addComment(payload);

      if (result.data) {
        const createdComment = {
          ...result.data,
          user: result.data.user || loggedUser || undefined,
        };
        setComments([...comments, createdComment]);
        setShowCommentPanel(true);
        setFocusedCommentId(createdComment.id!);
        setNewlyCreatedCommentId(createdComment.id!);
        return createdComment;
      }
    } catch (error) {
      console.error('Failed to add comment:', error);
    }
  };

  return { addCommentAtCoordinates };
};
